







import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class VSwitchButton extends Vue {
  @Prop({ default: false }) readonly value!: boolean;

  @Watch('value')
  onValueChange(value: boolean) {
    this.selected = value;
  }

  selected = this.value;

  get buttonClass() {
    return {
      'v-switch-button--selected': this.selected
    };
  }

  toggle() {
    this.selected = !this.selected;
    this.$emit('input', this.selected);
  }
}
